import { css } from 'styled-components';
import colors from '../../style/colors';
import { darken } from '../../style';

const variants = {
  action: css`
    background: ${colors.gray100};
    border: 2px dashed ${colors.gray400};
    &:hover:not(.disabled) {
      background: ${props => props.theme.actionLight};
      border-color: ${props => props.theme.actionColor};
    }
    &:active:not(.disabled) {
      border-color: ${props => props.theme.actionColor};
      background-color: ${props => darken(0.04, props.theme.actionLight)};
    }
  `,

  white: css`
    background: ${colors.white};
    border: 2px dashed ${colors.gray400};
    &:hover:not(.disabled) {
      background: ${props => props.theme.actionLight};
      border-color: ${props => props.theme.actionColor};

      * {
        color: ${props => props.theme.actionColor};
      }
    }
    &:active:not(.disabled) {
      border-color: ${props => props.theme.actionColor};
      background-color: ${props => darken(0.04, props.theme.actionLight)};
    }
  `,

  gray100: css`
    background-color: ${colors.gray100};
    border: 2px dashed ${colors.gray400};

    &:hover:not(.disabled) {
      border-color: ${colors.gray600};
      background-color: ${colors.gray300};
    }
    &:active:not(.disabled) {
      border-color: ${colors.gray600};
      background-color: ${darken(0.04, colors.gray300)};
    }
  `,
};

const sizes = {
  md: {
    height: '150px',
  },

  lg: {
    height: '230px',
  },

  xl: {
    height: '270px',
  },

  auto: {
    height: 'auto',
  },
};

export { variants, sizes };
